'use client';

import HelpFloatingIcon from '@/svg/main/help_floating.svg';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export default function FloatingFaqButton() {
  const router = useRouter();
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalElement(document.getElementById('portal'));
  }, []);

  const handleClick = () => {
    if (window.location.pathname.startsWith('/poi/')) {
      router.back();
      setTimeout(() => {
        router.push('/customercenter/faq');
      }, 100);
    } else {
      router.push('/customercenter/faq');
    }
  };

  if (!portalElement) return null;

  return createPortal(
    <button
      onClick={handleClick}
      className='fixed bottom-112pxr z-25'
      style={{
        right: 'max(20px, (calc(100vw - 480px) / 2) + 20px)',
      }}
    >
      <HelpFloatingIcon
        className='w-63pxr h-63pxr rounded-full'
        style={{
          boxShadow: '0 0 4px 0 rgba(177, 177, 177, 0.25) inset, 0 4px 4px 0 rgba(0, 0, 0, 0.25)',
        }}
      />
    </button>,
    portalElement,
  );
}
